export default {
  styleOverrides: {
    root: {
      // margin: 'inherit',
    },
  },
};
